import { Injectable } from '@angular/core';
import {LocalStorageService} from './local-storage.service';

@Injectable({
providedIn: 'root'
})
export class RouteTrackerService {
constructor(private localStorage: LocalStorageService) { }

setRoutes(previousRoute: string, currentRoute: string){
const routes = {
	previousRoute,
	currentRoute
};
this.localStorage.save('route-tracker', JSON.stringify(routes));
}
getRoutes(){
	const routes = {previousRoute: '', currentRoute: ''};
	let savedRoutes = this.localStorage.get('route-tracker');
	savedRoutes = savedRoutes ? JSON.parse(savedRoutes) : routes;
	return  savedRoutes;
}
}
